module.exports = __webpack_public_path__ + "static/media/loadData.d16f9c6c.svg";